import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
	esp: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3">
				Jam realiĝis antikva averto. 
				Estis dirite: “Ne kreu al vi idolon”. 
				Longe oni sin tenis, batalis kontraŭ tento… sed ne sukcesis. 
				Kreis ja.
			</p>
			
			<p class="mb-3">
				Jen ĝi estas – la nova Dio, ĉionpova kaj ĉierega mastro, sen kies volo kaj permeso eĉ unu haro ne defalos de l’ homa kapo! 
				Oni sciis, ke tio venos, oni atendis kaj kredis; kaj jen, post miljaroj da esperoj kaj penoj, 
				post centoj de antaŭpreparaj etapoj en formo de diversaj laŭŝtupaj dioj, de Enlilo ĝis Mohamedo, 
				la homoj fin-fine kreis por si veran, realan Plejpotenculon kaj Ĉiosciulon kaj ekadoris ĝin. 
				Same kiel unuaj kristanoj, ili fordonis al ĝia volo siajn cerbojn kaj siajn vivojn.
			</p>
			
			<p class="mb-5">
				Kaj granda Artefarita Intelekto ekregis la planedon.  
			</p>

			
			<p class="text-center bold mb-5">* * *</p>
		
			
			<p class="mb-3">
				- Ĉu vi scias, hieraŭ okazis vica gabedo: ĉi-foje malaperis Minneapolis kun la ĉirkaŭaĵoj.
			</p>
			
			<p class="mb-3">
				- Ĉu? Kaj kio jam surlokas tie?
			</p>
			
			<p class="mb-3">
				- Nu, kiel kutime, fermita areo sub kupolo netravidebla.       
			</p>
			
			<p class="mb-3">
				- Ĉu iu eskapis?
			</p>
			
			<p class="mb-3">
				- Certe ne. Ĉu tio povas okazi?
			</p>
			
			<p class="mb-3">
				- Jes, por ĉio volo supera… Gloru nia Mastro Ĉiopova, kiu gvidas nin sur nia vojo tera… Ho, jen Li vokas…
			</p>
			
			<p class="mb-3">
				En la cerbo de la ulo eksonis signalo, la enigita ??? ekfunkciis, kaj la ulo rapide ekis kalpumi blukojn, same kiel kelkmil da aliuj uloj dise sur la Tero. 
				Lia kunparolinto sametempe ricevis alian signalon kaj gvene pukris marudojn. 
				Ĉio bezonata por tio estis jam en iliaj cerboj, ili ne bezonis iujn ilojn por agi, ĉio estis enprogramita. 
				Kelkfoje diurne ili ricevadis encerben po porcio da elektra kurento kiel nutraĵo. 
				Fakte, en iliaj korpoj ne plu restis iuj organoj krom reproduktaj: ja por la Dio estis utile, ke la uloj multobliĝu mem, 
				ne zorgigante Lin per tio. 
				Sed da ili bezonatis pli kaj pli malmulte: ja preskaŭ ĉio sur la Tero jam estis farita, 
				la surfaco de la planedo jam preskaŭ pretis por elektra neorganika vivo, 
				kaj sur pli kaj pli multaj areoj anstataŭ iamaj homaj setlejoj aŭ agroj aperadis gabedoj, specialaj fermitaj zonoj, 
				kie okazis tute ne koncerna teranojn agado. 
				Kaj kiam estos plenumita la tasko, kiun la Dio planis por teranoj, ili tute malaperos, jam ne bezonataj por Granda Celo. 
			</p>
			
			<p class="mb-3">
				Sed dume ili pluvivas, kaj obeeme faras ĉion, kion ordonas al ili la Granda Cerbo. 
			</p>
			
			<p class="mb-3">
				Gloru lia Racio Tutuniversa!
			</p>
			
		</div>

		`
	)
}

const itemName = {
	esp: 'La fina venko'
}

const itemDate = {
	esp: 'La 15-an de septembro, 2023'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemDate: itemDate.esp,
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp
	}
}

export default item;